module.exports = __webpack_public_path__ + "static/media/hinted-Whitney-SemiBold.a9073ebb.woff";